/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Contract_Purchase_NumberInputs */

const en_cargo_contract_purchase_number = /** @type {(inputs: Cargo_Contract_Purchase_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract Purchase #`)
};

const es_cargo_contract_purchase_number = /** @type {(inputs: Cargo_Contract_Purchase_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero de compra de contrato`)
};

/**
* | output |
* | --- |
* | "Contract Purchase #" |
*
* @param {Cargo_Contract_Purchase_NumberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_contract_purchase_number = /** @type {((inputs?: Cargo_Contract_Purchase_NumberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Contract_Purchase_NumberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_contract_purchase_number(inputs)
	return es_cargo_contract_purchase_number(inputs)
});